<div class="shimmer">
  <ng-container *ngIf="loading"> 

    <ng-container *ngIf="type === 'grid'">
      <div *ngIf="showGridSkeleton" class="grid-skeleton">
        <ejs-skeleton *ngFor="let width of gridWidths" [width]="width" shimmerEffect="Wave" class="skeleton-text">
        </ejs-skeleton>
      </div>
    
      <div *ngIf="showGridError" class="error-message">
        Error fetching data.
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'counts'">
      <ejs-skeleton class="counts" width="30px" height="30px" shimmerEffect='Wave'></ejs-skeleton>
    </ng-container>

    <ng-container *ngIf="type === 'piechart'">
      <div *ngIf="showPieChartSkeleton" class="pie-skeleton-container">
        <ejs-skeleton class="e-skeleton" [height]="190" [width]="190" 
          [ngStyle]="{'background': conicGradient}" shimmerEffect="Wave">
        </ejs-skeleton>
      </div>
    
      <!-- <div *ngIf="showPieChartError" class="error-message">
        Error fetching data.
      </div> -->
    </ng-container>

    <ng-container *ngIf="type === 'barchart'">
      <div class="loader-style">
        <ejs-skeleton shape="Rectangle" width="100%" height="50px"></ejs-skeleton>
        <ejs-skeleton shape="Rectangle" width="90%" height="50px"></ejs-skeleton>
        <ejs-skeleton shape="Rectangle" width="80%" height="50px"></ejs-skeleton>
      </div>
    </ng-container>
    
  </ng-container>
</div>